import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ScrollToTop from '@/components/feature/ScrollToTop';
import HeroSection from './components/HeroSection';
import GameCategories from './components/GameCategories';
import LiveCasino from './components/LiveCasino';
import SportsBetting from './components/SportsBetting';
import Promotions from './components/Promotions';
import NewsSection from './components/NewsSection';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

const websiteStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: '金沙娱乐',
  alternateName: '金沙娱乐官方平台',
  url: 'https://www.jinshaentertainment.com',
  description: '金沙娱乐是您首选的顶级在线娱乐平台，提供丰富的游戏种类、安全可靠的支付环境与24小时专属客服。',
  potentialAction: {
    '@type': 'SearchAction',
    target: 'https://www.jinshaentertainment.com/search?q={search_term_string}',
    'query-input': 'required name=search_term_string',
  },
};

const organizationStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: '金沙娱乐',
  url: 'https://www.jinshaentertainment.com',
  description: '金沙娱乐官方平台 – 顶级在线娱乐平台',
  contactPoint: {
    '@type': 'ContactPoint',
    telephone: '400-888-9999',
    contactType: 'customer service',
    availableLanguage: 'Chinese',
  },
};

const webPageStructuredData = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '金沙娱乐官方平台 – 顶级娱乐体验尽在金沙娱乐',
  description: '金沙娱乐是您首选的顶级在线娱乐平台，提供丰富的游戏种类、安全可靠的支付环境与24小时专属客服。无论您热爱电子游戏、真人荷官还是体育竞技，金沙娱乐都能满足您的一切娱乐需求，立即注册享受专属新人礼遇。',
  url: 'https://www.jinshaentertainment.com/',
};

export default function Home() {
  return (
    <>
      <ScrollToTop />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(websiteStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(organizationStructuredData) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(webPageStructuredData) }}
      />
      <Navbar />
      <main>
        <article>
          <HeroSection />
          <GameCategories />
          <LiveCasino />
          <SportsBetting />
          <Promotions />
          <NewsSection />
          <FAQSection />
          <CTASection />
        </article>
      </main>
      <Footer />
    </>
  );
}